// currently supported locations
const DefaultLocations = [
  {
    label: "Alabama",
    value: "AL",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Alaska",
    value: "AK",
    territory: false,
    contiguous: false,
    supported: true,
  },
  {
    label: "American Samoa",
    value: "AS",
    territory: true,
    contiguous: false,
    supported: false,
  },
  {
    label: "Arizona",
    value: "AZ",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Arkansas",
    value: "AR",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "California",
    value: "CA",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Colorado",
    value: "CO",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Connecticut",
    value: "CT",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Delaware",
    value: "DE",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "District Of Columbia",
    value: "DC",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Federated States Of Micronesia",
    value: "FM",
    territory: true,
    contiguous: false,
    supported: false,
  },
  {
    label: "Florida",
    value: "FL",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Georgia",
    value: "GA",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Guam",
    value: "GU",
    territory: true,
    contiguous: false,
    supported: false,
  },
  {
    label: "Hawaii",
    value: "HI",
    territory: false,
    contiguous: false,
    supported: true,
  },
  {
    label: "Idaho",
    value: "ID",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Illinois",
    value: "IL",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Indiana",
    value: "IN",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Iowa",
    value: "IA",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Kansas",
    value: "KS",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Kentucky",
    value: "KY",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Louisiana",
    value: "LA",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Maine",
    value: "ME",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Marshall Islands",
    value: "MH",
    territory: true,
    contiguous: false,
    supported: false,
  },
  {
    label: "Maryland",
    value: "MD",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Massachusetts",
    value: "MA",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Michigan",
    value: "MI",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Minnesota",
    value: "MN",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Mississippi",
    value: "MS",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Missouri",
    value: "MO",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Montana",
    value: "MT",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Nebraska",
    value: "NE",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Nevada",
    value: "NV",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "New Hampshire",
    value: "NH",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "New Jersey",
    value: "NJ",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "New Mexico",
    value: "NM",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "New York",
    value: "NY",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "North Carolina",
    value: "NC",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "North Dakota",
    value: "ND",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Northern Mariana Islands",
    value: "MP",
    territory: true,
    contiguous: false,
    supported: false,
  },
  {
    label: "Ohio",
    value: "OH",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Oklahoma",
    value: "OK",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Oregon",
    value: "OR",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Palau",
    value: "PW",
    territory: true,
    contiguous: false,
    supported: false,
  },
  {
    label: "Pennsylvania",
    value: "PA",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Puerto Rico",
    value: "PR",
    territory: true,
    contiguous: false,
    supported: true,
  },
  {
    label: "Rhode Island",
    value: "RI",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "South Carolina",
    value: "SC",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "South Dakota",
    value: "SD",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Tennessee",
    value: "TN",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Texas",
    value: "TX",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Utah",
    value: "UT",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Vermont",
    value: "VT",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Virgin Islands",
    value: "VI",
    territory: true,
    contiguous: false,
    supported: false,
  },
  {
    label: "Virginia",
    value: "VA",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Washington",
    value: "WA",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "West Virginia",
    value: "WV",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Wisconsin",
    value: "WI",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Wyoming",
    value: "WY",
    territory: false,
    contiguous: true,
    supported: true,
  },
  {
    label: "Other",
    value: "Other",
    territory: false,
    contiguous: false,
    supported: true,
    invalid: true,
  },
];
export default DefaultLocations;
